class FeaturePointsComponent extends HTMLElement {

  constructor () {
    super()
    this.image        = this.querySelector('.feature-points__image');
    this.content      = this.querySelector('.feature-points__content');
    this.features     = this.querySelectorAll('.feature');

    

    this.features.forEach((feature, index) => {
      const spanElement = feature.querySelector('span');
      if (spanElement) {
        spanElement.textContent = `${index + 1}`;
      }
      if (index==0) {
        this.content.innerHTML = feature.querySelectorAll("template")[0].innerHTML;
      }
      feature.addEventListener('click', this.onFeatureClick.bind(this));
    });
  }

  onFeatureClick (event) {
    event.preventDefault();
    this.content.innerHTML = event.currentTarget.querySelectorAll("template")[0].innerHTML;
  }

  
}

customElements.define('feature-points-component', FeaturePointsComponent)